import * as React from 'react';
import { NestedTable } from 'react-inv-forms';
import { DetailsContainer, ButtonContainer } from './DetailsView.style';
import columnsAdapter from '../../../helpers/columnsAdapter';

export interface Props {
  /** lista kolumn */
  columns: SingleColumn[];
  /** dane do wyświetlenia w wierszach */
  data: SingleObjectDataStructure[];
  /** @ignore */
  children?: React.ReactNode;
}

const addTableKey = (array: object[]): object[] => array.map((item, idx) => ({ ...item, key: idx }));
/** 
 * Komponent prostego widoku szczegółowego 
 *  - generuje jedną tabelę z danymi 
 *  - umożliwia wygenerowanie dodatkowych elementów przekazywanych na pośrednictwem children 
 * 
 */
export class DetailsView extends React.Component<Props> {
  render(): React.ReactElement {
    return (
      <DetailsContainer>
        <NestedTable
          columns={columnsAdapter.removeSorter(this.props.columns)}
          dataSource={addTableKey(this.props.data)}
          pagination={false}
        />
        <ButtonContainer>
          {this.props.children}
        </ButtonContainer>
      </DetailsContainer>
    );
  }
}

export default DetailsView;